import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 bg-gradient-to-b from-slate-700 to-slate-800 text-white" data-id="element-27">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-28">
        {/* Icon */}
        <div className="flex justify-center mb-8" data-id="element-29">
          <div className="bg-orange-500 rounded-full p-6 shadow-xl" data-id="element-30">
            <ShieldCheck className="w-16 h-16 text-white" strokeWidth={2.5} data-id="element-31" />
          </div>
        </div>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-32">
          Garantía sin vueltas
        </h2>

        {/* Main Text */}
        <p className="text-xl text-slate-200 mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-33">
          Estamos tan seguros de que este Programa te va a encantar, que si no
          es así, te devolvemos el 100% de tu dinero.
        </p>

        {/* Secondary Text */}
        <p className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-34">
          Tenés <span className="font-bold text-white" data-id="element-35">7 días</span> para
          probarlo sin riesgo. Si no te convence, nos escribís y te hacemos el
          reembolso. Así de simple.
        </p>
      </div>
    </section>;
}